import { useCallback, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import Table from 'src/components/table/table'
import Filters from 'src/components/table/filters'
import {
  getClassroomsRequest,
  sendInviteRequest,
  deleteClassroomRequest,
} from 'src/services/api.service'
import { useNotification } from 'src/contexts/notification.context'
import { useAuth } from 'src/contexts/auth.context'

import { routes } from 'src/navigation/routes'
import InviteModal from './modals/invite'
import ClassroomRow from './components/classroom-row'

const statusOptions = [
  { label: 'Open', value: 'open' },
  { label: 'Closed', value: 'closed' },
]

const cacheKey = 'classrooms'

export const Classrooms = () => {
  const history = useHistory()
  const { cache, setCache } = useAuth()
  const { showErrorHelper, showNotificationHelper, showConfirm } =
    useNotification()

  const [loading, setLoading] = useState(false)
  const [data, setData] = useState(
    cache[cacheKey]?.data || {
      items: [],
      count: 0,
      pageCount: 1,
    },
  )
  const [filter, setFilter] = useState(
    cache[cacheKey]?.filter || {
      subject_id: null,
      grade_id: null,
      status: null,
      // period: null,
      query: '',
    },
  )
  const [lastFetchParams, setLastFetchParams] = useState({})

  const [isShowStudentsModal, setIsShowStudentsModal] = useState(false)
  const [selClassroom, setSelClassroom] = useState(null)

  const fetchData = useCallback(async ({ pageSize, pageIndex, filterData }) => {
    try {
      setLastFetchParams({ pageSize, pageIndex, filterData })
      setLoading(true)
      const response = await getClassroomsRequest({
        ...filterData,
        page: pageIndex + 1,
        perPage: pageSize,
      })
      const newData = {
        items: response.data.items,
        count: response.data.total,
        pageCount: Math.ceil(response.data.total / pageSize),
      }

      setData(newData)
      if (pageIndex === 0) {
        setCache({ [cacheKey]: { data: newData, filter: filterData } })
      }
    } catch (error) {
      showErrorHelper(error)
    }
    setLoading(false)
  }, [])

  // Row handlers
  const handleInviteClick = (item) => () => {
    setSelClassroom(item)
    setIsShowStudentsModal(true)
  }

  const handleCloseStudentsModal = () => {
    setIsShowStudentsModal(false)
  }

  const handleSubmitInviteStudent = async (values) => {
    try {
      await sendInviteRequest(values)
      setIsShowStudentsModal(false)
    } catch (error) {
      showErrorHelper(error)
    }
  }

  const handleDeleteClick = (item) => (e) => {
    e.preventDefault()
    showConfirm({
      title: 'Are you sure?',
      body: `Do you really want to delete the ${item.name}?`,
      actions: {
        onOk: async () => {
          await deleteClassroomRequest(item.id)
          showNotificationHelper({
            title: 'Success',
            body: 'Classroom has been deleted',
          })
          fetchData(lastFetchParams)
        },
      },
    })
  }

  const handleEditClick = (item) => (e) => {
    e.preventDefault()
    history.push(routes.classrooms.edit(item.id))
  }

  return (
    <>
      <h2 className="sectionHb-title">Classrooms</h2>

      <div className="sectionHb-block purchaseHb">
        <div className="sectionHb-block__wrap">
          <Filters
            buttonComponent={
              <Link
                to={routes.classrooms.new}
                className="primary-btn primary-btn__big"
              >
                <i className="hb-ico plus-ico-white" />
                Classroom
              </Link>
            }
            filter={filter}
            setFilter={setFilter}
            hidePeriod
            status={{
              options: statusOptions,
            }}
          />

          <Table
            fetchData={fetchData}
            data={data.items}
            pageCount={data.pageCount}
            filter={filter}
            loading={loading}
            // noItemsText = {<span>You have no classrooms yet. Set the first one <Link to={routes.classrooms.index}>here</Link></span>}
            rowComponent={(item) => (
              <ClassroomRow
                key={item.id}
                item={item}
                onInviteClick={handleInviteClick(item)}
                onDeleteClick={handleDeleteClick(item)}
                onEditClick={handleEditClick(item)}
              />
            )}
          />
        </div>
      </div>

      <div className={`mask__modal ${isShowStudentsModal ? 'active' : ''}`} />

      <InviteModal
        active={isShowStudentsModal}
        item={selClassroom}
        onClose={handleCloseStudentsModal}
        onSubmit={handleSubmitInviteStudent}
      />
    </>
  )
}
